import type { ReactNode } from "react";

/**
 * Render inline markdown emphasis — **bold** as <strong> and *italic* as <em> —
 * so asterisks never leak into the UI. Used everywhere prose or question text is
 * shown (the flow, the coach chat, the review/View screens). The canvas question
 * text itself carries *italic* emphasis (e.g. "what is it *not* for"), so this
 * must handle single asterisks too, not only bold.
 */
export function renderProse(text: string): ReactNode[] {
  if (!text) return [text];
  const parts: ReactNode[] = [];
  // **bold** first, then *italic* (inner has no '*', so pairs don't overlap).
  const re = /\*\*([^*]+?)\*\*|\*([^*]+?)\*/g;
  let last = 0;
  let key = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[1] !== undefined) parts.push(<strong key={key++}>{m[1]}</strong>);
    else parts.push(<em key={key++}>{m[2]}</em>);
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts.length ? parts : [text];
}
